import CommonStore from './commonStore';
import UserStore from './users';
import MainStore from './viewer';
import CompanyStore from './company';
import QuestionStore from './questions';
import AuthStore from './authStore';
import TrainingStore from './trainingStore';
import AssessmentStore from './assessments';
import BrandingStore from './brandingStore';
import InfosecStore from './infosecStore';
import Cmi5 from './cmi5';
import TestStore from './testStore';
import DemoStore from './demoStore';

const companyStore = new CompanyStore();
const userStore = new UserStore();
const brandingStore = new BrandingStore(companyStore);
const commonStore = new CommonStore(companyStore, brandingStore);
const questionStore = new QuestionStore(companyStore);
const authStore = new AuthStore(commonStore, companyStore, brandingStore);
const mainStore = new MainStore(commonStore, authStore, companyStore);

const trainingStore = new TrainingStore(authStore, companyStore, mainStore);
const assessmentStore = new AssessmentStore(
    authStore,
    companyStore,
    mainStore,
    commonStore
);

const cmi5Store = new Cmi5(authStore, companyStore, mainStore, commonStore);
const demoStore = new DemoStore(
    authStore,
    companyStore,
    mainStore,
    commonStore
);
mainStore.demoStore = demoStore;
brandingStore.authStore = authStore;
const stores = {
    authStore,
    store: mainStore,
    commonStore,
    brandingStore,
    userStore,
    companyStore,
    questionStore,
    trainingStore,
    assessmentStore,
    cmi5Store,
    demoStore,
    infosecStore: new InfosecStore(authStore),
    testStore: new TestStore(),
};

export default stores;
